export const name = '@rails-document';
export const nullDoc = {
  error: null,
  jsonapi: null,
  updates: undefined,
  request: null,
  pending: false,
  canceled: false,
};
